import { render, staticRenderFns } from "./periodicMaintenance.vue?vue&type=template&id=2612c294"
import script from "./periodicMaintenance.vue?vue&type=script&lang=js"
export * from "./periodicMaintenance.vue?vue&type=script&lang=js"
import style0 from "./periodicMaintenance.vue?vue&type=style&index=0&id=2612c294&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports